import home1 from "../../assets/img/IMG-20251108-WA0074.jpg";
import { Link } from "react-router-dom";
import { FiChevronRight } from "react-icons/fi";
const ourService = [
  { id: 1, name: "Landscape Design", url: "landscape-design" },
  { id: 2, name: "Hardscape", url: "hardscape" },
  { id: 3, name: "Landscape Lighting", url: "landscape-lighting" },
  { id: 4, name: "Softscape", url: "softscape" },
  { id: 5, name: "Plantation", url: "plantation" },
  { id: 6, name: "Replanting", url: "replanting" },
  {
    id: 7,
    name: "Lawn Development and Maintenance",
    url: "lawn-development-and-maintenance",
  },
  {
    id: 8,
    name: "Horticultural Maintenance",
    url: "horticultural-maintenance",
  },
  {
    id: 9,
    name: "Vertical & Terrace Garden",
    url: "vertical-and-terrace-garden",
  },
  { id: 10, name: "Irrigation System", url: "irrigation-system" },
];

function LandscapeLighting() {
  return (
    <>
      <section className="serviceList sectionPD">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="aboutImg">
                <img src={home1} alt="About" className="img-fluid" />
              </div>
              <div className="blogCategory mt-4">
                <ul>
                  {ourService.map((item) => {
                    return (
                      <li key={item.id}>
                        <Link to={`${item.url}`}>
                          <FiChevronRight />
                          {item.name}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="fisherman-content">
                <h6>Illuminating Outdoor Spaces With Beauty and Purpose</h6>
                <h3>About Landscape Lighting</h3>
                <p>
                  Landscape lighting is not just about brightness — it’s about
                  mood, depth, and feeling. The right lighting can turn an
                  ordinary garden into something magical after sunset. It
                  highlights textures, guides movement, and adds warmth to the
                  night.
                </p>
                <p>
                  Good lighting design doesn’t try to compete with nature; it
                  works with it. The goal is not to flood the space with light,
                  but to create gentle layers that reveal the beauty of plants,
                  pathways, and stonework. A soft glow on a tree trunk, subtle
                  lights along a walkway, or warm tones around a sitting area —
                  these small touches bring life to the outdoors even when the
                  sun goes down.
                </p>
                <p>
                  Real landscape lighting design begins with understanding the
                  space — how people use it, how shadows fall, and how to make
                  it feel welcoming and safe without losing its natural charm.
                </p>
                <p>
                  In a world full of bright, harsh lights, the most authentic
                  lighting feels calm and understated. It lets you see just
                  enough — the shape of a leaf, the edge of a wall, the sparkle
                  of water — and leaves the rest to imagination.
                </p>
                <p>
                  At its best, landscape lighting doesn’t just illuminate; it
                  connects. It lets people enjoy their outdoor spaces at night
                  in a way that feels peaceful, grounded, and alive.
                </p>
              </div>

              <div className="fisherman-content">
                <h5>💡 Light Up Your Landscape the Right Way</h5>
                <p>
                  Whether you're looking for subtle elegance or bold dramatic
                  lighting, our team can help design and install a system
                  tailored to your space and style.
                </p>
                <Link
                  href="mailto:info@example.com"
                  className="commonButton mt-3"
                >
                  📧 Contact Us Today
                </Link>
              </div>
            </div>
          </div>
          <div className="fisherman-content">
            <h4>🔦 Types of Landscape Lighting</h4>
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Type</th>
                  <th>Purpose/Placement</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Path Lights</td>
                  <td>Along walkways, driveways, and garden paths</td>
                </tr>
                <tr>
                  <td>Spotlights</td>
                  <td>Focused beams to highlight trees or statues</td>
                </tr>
                <tr>
                  <td>Floodlights</td>
                  <td>Wide beams for area lighting or security</td>
                </tr>
                <tr>
                  <td>Well Lights</td>
                  <td>In-ground fixtures for uplighting</td>
                </tr>
                <tr>
                  <td>Step &amp; Deck Lights</td>
                  <td>Mounted on stairs, walls, or under steps</td>
                </tr>
                <tr>
                  <td>String/Festoon Lights</td>
                  <td>Over patios or decks for ambiance</td>
                </tr>
                <tr>
                  <td>Bollard Lights</td>
                  <td>Short posts with light all around</td>
                </tr>
                <tr>
                  <td>Underwater Lights</td>
                  <td>In ponds, fountains, or water features</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="fisherman-content d-none">
            <h4>🌟 Why Landscape Lighting Matters</h4>
            <p>
              Landscape lighting is the art and science of strategically placing
              lights throughout outdoor spaces to enhance visibility, safety,
              mood, and aesthetics after dark. It's not just about seeing better
              — it’s about <strong>creating atmosphere</strong>,{" "}
              <strong>showcasing design</strong>, and{" "}
              <strong>extending usability</strong> into the night.
            </p>
            <ul>
              <li>
                🌙 <strong>Enhancing beauty</strong> – Highlight plants,
                architectural elements, and focal points
              </li>
              <li>
                🛡️ <strong>Improving safety</strong> – Prevent trips and falls
                by lighting walkways and stairs
              </li>
              <li>
                🔐 <strong>Boosting security</strong> – Deter intruders with
                well-lit surroundings
              </li>
              <li>
                🎉 <strong>Creating ambiance</strong> – Set the mood for
                entertaining or relaxing
              </li>
              <li>
                ⏱️ <strong>Extending usability</strong> – Enjoy your landscape
                long after the sun goes down
              </li>
            </ul>
          </div>
          <div className="fisherman-content d-none">
            <h4>🧠 Smart Lighting &amp; Automation</h4>
            <ul>
              <li>Timers and sensors to automate dusk-to-dawn lighting</li>
              <li>Motion sensors for added security</li>
              <li>Smart app control to adjust lighting remotely</li>
              <li>Color-changing LEDs for mood and seasonal settings</li>
            </ul>
          </div>
          <div className="fisherman-content d-none">
            <h4>🎨 Landscape Lighting Design Tips</h4>
            <ul>
              <li>
                Use <strong>layers</strong> of light: ambient, task, and accent
              </li>
              <li>Avoid over-lighting; subtle is often more elegant</li>
              <li>
                Highlight focal points like trees, fountains, or sculptures
              </li>
              <li>Use warm white light (2700K–3000K) for a natural look</li>
              <li>
                Consider how lighting looks from <strong>inside</strong> your
                home too
              </li>
            </ul>
          </div>
          <div className="fisherman-content d-none">
            <h4>🛠️ Our Landscape Lighting Services Include:</h4>
            <ul>
              <li>Custom lighting design and layout</li>
              <li>LED lighting installation</li>
              <li>Pathway and stair lighting</li>
              <li>Uplighting for trees and architecture</li>
              <li>Garden and accent lighting</li>
              <li>Deck, patio, and water feature lighting</li>
              <li>Smart control system setup and automation</li>
            </ul>
          </div>
        </div>
      </section>
    </>
  );
}

export default LandscapeLighting;
